import React from "react";

export const getMax7Array = (conversionArray: any) => {
  const finalConversionsArray: {
    [x: string]: string | number;
    name: string;
    abreviated_name: string;
  }[] = [];

  let max7 = 0;
  conversionArray.forEach((obj: any) => {
    if (max7 > 6) return;
    finalConversionsArray.push(obj);
    max7 += 1;
  });

  const totalsArray: (
    | number
    | {
        [x: string]: string | number;
        name: string;
        abreviated_name: string;
      }
  )[][] = [];

  finalConversionsArray.forEach((obj) => {
    let total = 0;
    for (const key in obj) {
      if (key !== "name" && key !== "abreviated_name") {
        total += Number(obj[key]);
      }
    }
    totalsArray.push([total, obj]);
  });

  type LocalFunction = (a: any, b: any) => number;

  const sortingFucntion: LocalFunction = (a, b) => {
    return b[0] - a[0];
  };

  totalsArray.sort(sortingFucntion);

  const finalArray: any[] = [];

  totalsArray.forEach((array: any[]) => {
    finalArray.push(array[1]);
  });

  return finalArray;
};
